const Pictures = ({ images, setImages, mainImageId, setMainImageId }) => {
  const handleFileChange = (e) => {
    const files = [];

    for (let i = 0; i < e.target.files.length; i++) {
      files.push({
        preview: URL.createObjectURL(e.target.files[i]),
        data: e.target.files[i],
        id: `new+${Date.now()}+${i}`,
      });
    }

    setImages([...images, ...files]);
  };

  return (
    <div className="AddInfoContainer">
      <div className="otherPhotos">
        <div className="mainPhotoHeader">
          <input
            className="hidden"
            multiple={true}
            type="file"
            title="سایر عکس ها"
            id="uploadMainPic"
            onChange={handleFileChange}
          />
          <label
            className="dashboardHeader keepRight clickable"
            htmlFor="uploadMainPic"
          >
            <p>بارگزاری عکس</p>
            <i className="uploadSvg"></i>
          </label>
          <span className="mainPhotoTitle">
            <p>گالری</p>
            <p className="sideBarTitle">
              برای انتخاب عکس اصلی روی آن کلیک کنید
            </p>
          </span>
        </div>
        <div className="otherPhotosContainer">
          {images?.map((image) => (
            <span key={image.id} className="galleryImageWrapper">
              <img
                src={image.preview}
                className={`galleryImages${mainImageId === image.id ? " selectedImage" : ""}`}
                onClick={() =>
                  setMainImageId((prev) =>
                    prev === image.id ? null : image.id,
                  )
                }
              />
              {mainImageId === image.id && (
                <span className="mainImageBadge">اصلی</span>
              )}
              <i
                className="delPicOther"
                onClick={() => {
                  if (mainImageId === image.id) setMainImageId(null);
                  setImages((prev) => prev.filter((e) => e.id !== image.id));
                }}
              ></i>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Pictures;
